import React from "react";
import { Box, Typography } from "@mui/material";

export interface FinesReceiptRowProps {
  label: string;
  value: string | undefined;
  labelTextAlign?: "left" | "center" | "right";
}

export const FinesReceiptRow: React.FC<FinesReceiptRowProps> = ({
  label,
  value,
  labelTextAlign = "left",
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr auto", sm: "1fr auto" },
      columnGap: 1,
      mb: 0,
    }}
  >
    <Box>
      <Typography
        textAlign={labelTextAlign}
        variant="body2"
        color="text.secondary"
        sx={{ lineHeight: 1.2 }}
      >
        {label}
      </Typography>
    </Box>
    <Box>
      <Typography
        textAlign="right"
        variant="body2"
        fontWeight={500}
        sx={{ wordBreak: "break-word", lineHeight: 1.2 }}
      >
        {value || "-"}
      </Typography>
    </Box>
  </Box>
);
